import {
  VirusScanStatus,
  FILES_VALIDATION_PROCESSING_FILES,
  FILES_VALIDATION_MALICIOUS_CONTENT,
  FILES_VALIDATION_FAILED,
  FILE_VALIDATION_MALICIOUS_CONTENT,
  FILE_VALIDATION_FAILED,
} from 'hb-react/shared/hooks/useGlobalStorageV2/constants';
import type { GlobalStorageFile } from 'hb-react/shared/hooks/useGlobalStorageV2/types';
import { areFilesReadyToSubmit } from 'hb-react/shared/hooks/useGlobalStorageV2/utils';

export const getFileValidator =
  (virusScanningEnabled) => (value?: GlobalStorageFile | null) => {
    if (!value) {
      return;
    }

    const { isRemoved, virusScanStatus, error } = value;

    if (!isRemoved && virusScanStatus === VirusScanStatus.INFECTED) {
      return FILE_VALIDATION_MALICIOUS_CONTENT;
    }

    if (!isRemoved && error) {
      return FILE_VALIDATION_FAILED;
    }

    const readyToSubmit = areFilesReadyToSubmit([value], virusScanningEnabled);

    if (!readyToSubmit) {
      return FILES_VALIDATION_PROCESSING_FILES;
    }
  };

export const getFilesValidator =
  (virusScanningEnabled) =>
  (value: GlobalStorageFile[] = []) => {
    if (
      value.some(
        ({ isRemoved, virusScanStatus }) =>
          !isRemoved && virusScanStatus === VirusScanStatus.INFECTED,
      )
    ) {
      return FILES_VALIDATION_MALICIOUS_CONTENT;
    }

    if (value.some(({ isRemoved, error }) => !isRemoved && error)) {
      return FILES_VALIDATION_FAILED;
    }

    const readyToSubmit = areFilesReadyToSubmit(value, virusScanningEnabled);

    if (!readyToSubmit) {
      return FILES_VALIDATION_PROCESSING_FILES;
    }
  };
